<template>
  <span class="order-detail-status-badge" :class="`-is-${variant}`">
    <v-icon
      v-if="icon"
      size="16"
      class="order-detail-status-badge__icon"
    >
      {{ icon }}
    </v-icon>

    <span class="order-detail-status-badge__label">{{ label }}</span>
  </span>
</template>

<script>
import { ORDER_STATUS } from '@/config/order'

const STATUS_META = Object.freeze({
  [ORDER_STATUS.CREATE]: {
    label: 'รอชำระเงิน',
    variant: 'blue',
    icon: 'mdi-dots-horizontal',
  },
  [ORDER_STATUS.PROCESS]: {
    label: 'กำลังดำเนินการ',
    variant: 'blue',
    icon: 'mdi-dots-horizontal',
  },
  [ORDER_STATUS.COMPLETE]: {
    label: 'สั่งซื้อสำเร็จ',
    variant: 'green',
    icon: 'mdi-check-circle-outline',
  },
  [ORDER_STATUS.PRE_COMPLETE]: {
    label: 'รอลูกค้าชำระเงินค้ำประกัน',
    variant: 'blue',
    icon: 'mdi-dots-horizontal',
  },
  [ORDER_STATUS.SUCCESS]: {
    label: 'ชำระเงินสำเร็จ',
    variant: 'green',
    icon: 'mdi-check-circle-outline',
  },
  [ORDER_STATUS.CANCEL]: {
    label: 'ถูกยกเลิก',
    variant: 'red',
    icon: 'mdi-close-circle-outline',
  },
  [ORDER_STATUS.OK]: {
    label: 'รอลูกค้าชำระเงินส่วนที่เหลือ',
    variant: 'orange',
    icon: 'mdi-clock-outline',
  },
  [ORDER_STATUS.EXPIRED]: {
    label: 'หมดอายุ',
    variant: 'gray',
    icon: 'mdi-close-circle-outline',
  },

  // VIP order status
  [ORDER_STATUS.VIP_PENDING]: {
    label: 'ลงทะเบียนสำเร็จ',
    variant: 'green',
    icon: 'mdi-check-circle-outline',
  },
  [ORDER_STATUS.VIP_CONVERTED]: {
    label: 'รอชำระเงิน',
    variant: 'orange',
    icon: 'mdi-clock-outline',
  },
  [ORDER_STATUS.VIP_EXPIRED]: {
    label: 'หมดอายุ',
    variant: 'gray',
    icon: 'mdi-close-circle-outline',
  },
})

export default {
  name: 'OrderDetailStatusBadge',

  props: {
    status: {
      type: String,
      required: true,
    },
  },

  computed: {
    meta() {
      return (
        STATUS_META[this.status] || {
          label: this.status,
          variant: 'gray',
          icon: 'mdi-close-circle-outline',
        }
      )
    },
    label() {
      return this.meta.label
    },
    variant() {
      return this.meta.variant
    },
    icon() {
      return this.meta.icon
    },
  },
}
</script>

<style lang="stylus" scoped>
.order-detail-status-badge {
    display: inline-flex
    align-items: center
    gap: 4px
    padding: 4px 8px
    border-radius: 999px
    font-family: "SF Pro Text"
    font-size: 12px
    font-weight: 600
    line-height: 1
    white-space: nowrap
}

.order-detail-status-badge__icon {
    flex-shrink: 0
}

.order-detail-status-badge__label {
    display: inline-block
}

.-is-green {
    background-color: #E3F6E8
    color: #2FAE59

	.order-detail-status-badge__icon {
		color: #2FAE59
	}
}

.-is-blue {
    background-color: #E7F1FE
    color: #2F80ED

	.order-detail-status-badge__icon {
		color: #2F80ED
	}
}

.-is-orange {
    background-color: #FFEFE2
    color: #F2892E

	.order-detail-status-badge__icon {
		color: #F2892E
	}
}

.-is-red {
    background-color: #FDEAEC
    color: #EB4C61

	.order-detail-status-badge__icon {
		color: #EB4C61
	}
}

.-is-gray {
    background-color: #F0F0F0
    color: #8C8C8C

	.order-detail-status-badge__icon {
		color: #8C8C8C
	}
}
</style>
